(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/create-jupiter-instance.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/create-jupiter-instance.js');
'use strict';

const jupiterFetch = svs.core.jupiterFetch;
const createJupiterInstance = () => async function () {
  const response = await jupiterFetch.fetch(...arguments);
  const data = await response.json();
  if (!response.ok) {
    var _data$error;
    throw new Error((_data$error = data.error) !== null && _data$error !== void 0 ? _data$error : 'Error occurred while fetching');
  }
  return data;
};
setGlobal('svs.components.sport.raceHandler.createJupiterInstance', createJupiterInstance);

 })(window);